import { render } from "./index.vue?vue&type=template&id=0891fe8b&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=0891fe8b&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Administrator\\Code\\vue\\xypt-admin-wx\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0891fe8b"]])

export default __exports__